import { useAuth } from '@auth/auth'
import useUserVerification from '@hooks/useUserVerification'
import React from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

const SettingsWrapper = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { isFreeUser, isEarlyBirdAccessUser, isAppSumoUser, isWhiteLabelUser, isExcludedIntegrationFeature } = useUserVerification()
  const { canEdit } = useAuth()

  // Extract the current tab from the URL path
  const pathParts = location.pathname.split('/')
  const currentTab = pathParts[pathParts.length - 1]

  // Handle tab changes - this will be called by your SettingsUpdated component
  const handleTabChange = (newTab) => {
    const tabRoutes = {
      0: 'myAccount',
      1: 'workspace',
      2: 'myPlan',
      3: 'billing',
      4: 'upgrade',
      5: 'integrations',
      6: 'blocklist'

    }

    const route = tabRoutes[newTab]
    if (route) {
      navigate(`/settingsUpdated/${route}`)
    }
  }

  return (
    <div className='settings-wrapper'>
      <Outlet context={{ handleTabChange, currentTab, isFreeUser, isEarlyBirdAccessUser, isAppSumoUser, isWhiteLabelUser, isExcludedIntegrationFeature, canEdit }} />
    </div>
  )
}

export default SettingsWrapper
